import { useState } from 'react';
import { Link } from 'react-router-dom';

interface Sistema {
  slug: string;
  name: string;
  shortDesc: string;
  fullDesc: string;
  to: string;
}

// ─── 21 Mystical SVG Line Icons ──────────────────────────────────────────────

function IconMapaAstral() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <circle cx="24" cy="24" r="20" />
      <circle cx="24" cy="24" r="12" />
      <circle cx="24" cy="24" r="3" fill="currentColor" stroke="none" />
      {Array.from({ length: 12 }, (_, i) => {
        const a = ((i * 30 - 90) * Math.PI) / 180;
        return <line key={i} x1={24 + 12 * Math.cos(a)} y1={24 + 12 * Math.sin(a)} x2={24 + 20 * Math.cos(a)} y2={24 + 20 * Math.sin(a)} />;
      })}
    </svg>
  );
}

function IconPrevisao() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <rect x="5" y="11" width="38" height="30" rx="3" />
      <line x1="5" y1="20" x2="43" y2="20" />
      <line x1="14" y1="6" x2="14" y2="16" />
      <line x1="34" y1="6" x2="34" y2="16" />
      <path d="M24,24 L25.5,28.5 L30.5,28.5 L26.5,31.2 L27.8,36 L24,33.2 L20.2,36 L21.5,31.2 L17.5,28.5 L22.5,28.5 Z" />
    </svg>
  );
}

function IconPergunteAosAstros() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <path d="M18,17 C18,12 21,9 24,9 C27,9 30,11.5 30,15.5 C30,19.5 26.5,21.5 24.5,24 L24.5,28" />
      <circle cx="24.5" cy="33" r="1.8" fill="currentColor" stroke="none" />
      <circle cx="10" cy="12" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="38" cy="15" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="40" cy="36" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="9" cy="34" r="1.3" fill="currentColor" stroke="none" />
      <path d="M36,8 L37,10.5 L39.5,11.5 L37,12.5 L36,15 L35,12.5 L32.5,11.5 L35,10.5 Z" />
    </svg>
  );
}

function IconSinastria() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <circle cx="17" cy="24" r="13" />
      <circle cx="31" cy="24" r="13" />
      <circle cx="24" cy="21" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="24" cy="27" r="1.5" fill="currentColor" stroke="none" />
    </svg>
  );
}

function IconAstrocartografia() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <circle cx="24" cy="24" r="20" />
      <ellipse cx="24" cy="24" rx="9" ry="20" />
      <line x1="4" y1="24" x2="44" y2="24" />
      <path d="M6,16 Q24,21 42,16" />
      <path d="M6,32 Q24,27 42,32" />
    </svg>
  );
}

function IconNumerologia() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <polygon points="24,5 43,37 5,37" />
      <polygon points="24,43 43,11 5,11" />
      <circle cx="24" cy="24" r="5" />
    </svg>
  );
}

function IconTaroMarselha() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <g transform="rotate(-18 18 32)">
        <rect x="9" y="12" width="10" height="16" rx="1.5" />
      </g>
      <rect x="19" y="9" width="10" height="16" rx="1.5" />
      <g transform="rotate(18 30 32)">
        <rect x="29" y="12" width="10" height="16" rx="1.5" />
      </g>
      <path d="M24,12 L25,14.5 L27.5,14.5 L25.5,16 L26.3,18.5 L24,17 L21.7,18.5 L22.5,16 L20.5,14.5 L23,14.5 Z" />
    </svg>
  );
}

function IconIChing() {
  const LINES = [
    { y: 11, broken: false },
    { y: 18, broken: true },
    { y: 25, broken: false },
    { y: 32, broken: true },
    { y: 39, broken: false },
  ];
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" width="48" height="48">
      {LINES.map(({ y, broken }, i) =>
        broken ? (
          <g key={i}>
            <line x1="8" y1={y} x2="19" y2={y} />
            <line x1="29" y1={y} x2="40" y2={y} />
          </g>
        ) : (
          <line key={i} x1="8" y1={y} x2="40" y2={y} />
        )
      )}
    </svg>
  );
}

function IconHumanDesign() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <polygon points="24,4 30,11 24,18 18,11" />
      <polygon points="24,19 31,27 24,35 17,27" />
      <line x1="24" y1="18" x2="24" y2="19" />
      <line x1="17" y1="27" x2="10" y2="22" />
      <line x1="31" y1="27" x2="38" y2="22" />
      <circle cx="10" cy="22" r="3" />
      <circle cx="38" cy="22" r="3" />
      <path d="M17,35 Q24,42 31,35" />
    </svg>
  );
}

function IconTaroCigano() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      {[-30, -15, 0, 15, 30].map((angle, i) => (
        <g key={i} transform={`rotate(${angle} 24 42)`}>
          <rect x="19.5" y="14" width="9" height="14" rx="1.5" />
        </g>
      ))}
    </svg>
  );
}

function IconAstrologiaVedica() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <circle cx="24" cy="24" r="21" />
      <polygon points="24,5 41,35 7,35" />
      <polygon points="24,43 41,13 7,13" />
      <circle cx="24" cy="24" r="5" />
    </svg>
  );
}

function IconAstroPet() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <ellipse cx="24" cy="35" rx="8" ry="6" />
      <ellipse cx="13" cy="25" rx="4" ry="3" />
      <ellipse cx="20" cy="20" rx="4" ry="3" />
      <ellipse cx="28" cy="20" rx="4" ry="3" />
      <ellipse cx="35" cy="25" rx="4" ry="3" />
      <path d="M38,7 L39.2,10.5 L43,11.5 L39.2,12.5 L38,16 L36.8,12.5 L33,11.5 L36.8,10.5 Z" />
    </svg>
  );
}

function IconAstromatch() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <path d="M13,21 C13,17 17,14 21,19 C25,14 29,17 29,21 C29,27 21,34 21,34 C21,34 13,27 13,21 Z" />
      <path d="M19,19 C19,15 23,12 27,17 C31,12 35,15 35,19 C35,25 27,32 27,32 C27,32 19,25 19,19 Z" />
    </svg>
  );
}

function IconRotaProfissional() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <circle cx="24" cy="24" r="20" />
      <circle cx="24" cy="24" r="2.5" fill="currentColor" stroke="none" />
      <path d="M24,6 L21.5,21 L24,19.5 L26.5,21 Z" fill="currentColor" />
      <path d="M24,42 L21.5,27 L24,28.5 L26.5,27 Z" />
      <line x1="4" y1="24" x2="10" y2="24" />
      <line x1="38" y1="24" x2="44" y2="24" />
    </svg>
  );
}

function IconDiarioDeSonhos() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <path d="M28,8 A18,18 0 0,1 28,40 A14,14 0 0,0 28,8 Z" />
      <circle cx="11" cy="16" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="10" cy="30" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="40" cy="12" r="1.5" fill="currentColor" stroke="none" />
      <path d="M38,28 L39.5,30 L41,28 L39.5,26 Z M38,28 L40,29.5 L42,28 L40,26.5 Z" fill="currentColor" stroke="none" />
      <path d="M13,8 L14,11 L17,12 L14,13 L13,16 L12,13 L9,12 L12,11 Z" />
    </svg>
  );
}

function IconAstroCoach() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <circle cx="24" cy="10" r="5" />
      <line x1="24" y1="15" x2="24" y2="27" />
      <path d="M24,20 L14,27 L13,31" />
      <path d="M24,20 L34,27 L35,31" />
      <path d="M13,42 Q18,36 24,36 Q30,36 35,42" />
      <circle cx="24" cy="21" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="24" cy="21" r="7" strokeDasharray="2,3" opacity="0.5" />
    </svg>
  );
}

function IconRadarRetrogrado() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <circle cx="24" cy="24" r="10" />
      <ellipse cx="24" cy="24" rx="16" ry="5.5" />
      <path d="M39,16 A20,20 0 0,0 9,16" />
      <path d="M8,13 L9,16 L12.5,14.5" />
    </svg>
  );
}

function IconEclipseInsight() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      {[0, 45, 90, 135, 180, 225, 270, 315].map((deg, i) => {
        const a = (deg * Math.PI) / 180;
        return <line key={i} x1={22 + 17 * Math.cos(a)} y1={24 + 17 * Math.sin(a)} x2={22 + 21 * Math.cos(a)} y2={24 + 21 * Math.sin(a)} />;
      })}
      <circle cx="22" cy="24" r="13" />
      <circle cx="28" cy="24" r="13" />
    </svg>
  );
}

function IconFasesDaLua() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <circle cx="6" cy="24" r="5" />
      <circle cx="18" cy="24" r="5" />
      <path d="M18,19 A5,5 0 0,1 18,29 Z" fill="currentColor" stroke="none" />
      <circle cx="30" cy="24" r="5" fill="currentColor" />
      <circle cx="42" cy="24" r="5" />
      <path d="M42,19 A5,5 0 0,0 42,29 Z" fill="currentColor" stroke="none" />
    </svg>
  );
}

function IconGrafologia() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <path d="M36,6 C42,10 42,22 34,28 C28,32 22,36 18,44 L20,38 C13,34 12,26 16,20 C20,14 32,8 36,6 Z" />
      <line x1="18" y1="44" x2="36" y2="6" />
      <path d="M18,44 L14,47 L20,46" />
      <line x1="28" y1="15" x2="22" y2="21" />
      <line x1="32" y1="11" x2="26" y2="17" />
    </svg>
  );
}

function IconAgendaAstrologica() {
  return (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="48" height="48">
      <rect x="4" y="10" width="40" height="32" rx="3" />
      <line x1="4" y1="19" x2="44" y2="19" />
      <line x1="14" y1="6" x2="14" y2="14" />
      <line x1="34" y1="6" x2="34" y2="14" />
      <circle cx="12" cy="26" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="24" cy="26" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="12" cy="35" r="1.5" fill="currentColor" stroke="none" />
      <path d="M32,22 A8,8 0 0,1 32,38 A6,6 0 0,0 32,22 Z" />
    </svg>
  );
}

const ICON_MAP: Record<string, React.FC> = {
  'mapa-astral':          IconMapaAstral,
  'previsao-personalizada': IconPrevisao,
  'pergunte-aos-astros':  IconPergunteAosAstros,
  'sinastria':            IconSinastria,
  'astrocartografia':     IconAstrocartografia,
  'numerologia':          IconNumerologia,
  'tarot-marselha':       IconTaroMarselha,
  'i-ching':              IconIChing,
  'human-design':         IconHumanDesign,
  'tarot-cigano':         IconTaroCigano,
  'astrologia-vedica':    IconAstrologiaVedica,
  'astro-pet':            IconAstroPet,
  'astromatch':           IconAstromatch,
  'rota-profissional':    IconRotaProfissional,
  'diario-de-sonhos':     IconDiarioDeSonhos,
  'astro-coach':          IconAstroCoach,
  'radar-retrogrado':     IconRadarRetrogrado,
  'eclipse-insight':      IconEclipseInsight,
  'fases-da-lua':         IconFasesDaLua,
  'grafologia':           IconGrafologia,
  'agenda-astrologica':   IconAgendaAstrologica,
};

function SistemaIcon({ slug }: { slug: string }) {
  const Icon = ICON_MAP[slug];
  return Icon ? <Icon /> : (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" width="48" height="48">
      <circle cx="24" cy="24" r="20" />
      <circle cx="24" cy="24" r="4" fill="currentColor" stroke="none" />
    </svg>
  );
}

// ─── Data ────────────────────────────────────────────────────────────────────

const SISTEMAS: Sistema[] = [
  {
    slug: 'mapa-astral',
    name: 'Mapa Astral',
    shortDesc: 'Mapa natal, trânsitos e progressões',
    fullDesc: 'O sistema mais completo do Ocidente. Analisa as posições de todos os planetas, casas astrológicas e aspectos no momento exato do seu nascimento para revelar sua personalidade, potenciais e ciclos de vida.',
    to: '/servicos/mapa-astral',
  },
  {
    slug: 'previsao-personalizada',
    name: 'Previsão Pessoal',
    shortDesc: 'Trânsitos diários, semanais e mensais',
    fullDesc: 'Os movimentos dos planetas lidos especificamente para o seu mapa natal. Saiba como os trânsitos de hoje, desta semana e deste mês afetam você em particular, não um texto genérico de signo.',
    to: '/servicos/previsao-personalizada',
  },
  {
    slug: 'sinastria',
    name: 'Sinastria',
    shortDesc: 'Compatibilidade e previsão para o casal',
    fullDesc: 'A análise de como dois mapas natais se encontram. Revela harmonia, tensões, compatibilidade real e a previsão dos próximos 3 meses para ambos, para saber se estão no momento certo para estarem juntos.',
    to: '/servicos/sinastria',
  },
  {
    slug: 'tarot-marselha',
    name: 'Tarô de Marselha',
    shortDesc: 'Arcanos Maiores e Menores',
    fullDesc: 'Tiragens personalizadas com interpretação baseada no seu mapa natal. Disponível em Cruz Celta, Três Cartas, Tiragem Anual e outros spreads clássicos.',
    to: '/servicos/tarot-marselha',
  },
  {
    slug: 'i-ching',
    name: 'I Ching',
    shortDesc: 'O Livro das Mutações, 64 hexagramas',
    fullDesc: 'Oráculo chinês de 3000 anos com 64 hexagramas que espelham as mutações do universo. Cada consulta gera uma leitura interpretada para o seu momento e pergunta específica.',
    to: '/servicos/i-ching',
  },
  {
    slug: 'numerologia',
    name: 'Numerologia',
    shortDesc: 'Kabbalística, Pitagórica e Caldeia',
    fullDesc: 'Três tradições numerológicas em uma só plataforma. Revela o significado oculto do seu nome e data de nascimento, seus números de caminho de vida, destino e vibração pessoal.',
    to: '/servicos/numerologia',
  },
  {
    slug: 'tarot-cigano',
    name: 'Tarot Cigano',
    shortDesc: '36 cartas de oráculo narrativo',
    fullDesc: 'O oráculo das 36 cartas de Lenormand. Altamente preciso para questões práticas do dia a dia em trabalho, amor e finanças, com narrativas encadeadas entre cartas.',
    to: '/servicos/tarot-cigano',
  },
  {
    slug: 'human-design',
    name: 'Human Design',
    shortDesc: 'Síntese de astrologia, I Ching e Kabbalá',
    fullDesc: 'Sistema que combina astrologia, I Ching, Kabbalá e bioquímica para revelar seu tipo energético (Gerador, Projetor, Manifestador ou Refletor) e sua estratégia de vida.',
    to: '/servicos/human-design',
  },
  {
    slug: 'astrocartografia',
    name: 'Astrocartografia',
    shortDesc: 'Como os lugares afetam seu destino',
    fullDesc: 'Mapeamento das linhas planetárias ao redor do mundo que revela quais lugares amplificam amor, sucesso, criatividade ou crescimento espiritual para você especificamente.',
    to: '/servicos/astrocartografia',
  },
  {
    slug: 'astrologia-vedica',
    name: 'Astrologia Védica',
    shortDesc: 'Jyotish, o zodíaco sideral indiano',
    fullDesc: 'O Jyotish, ou "luz dos astros" em sânscrito, é a astrologia tradicional indiana. Usa o zodíaco sideral e foca no Nakshatra (mansão lunar) para revelar seu dharma e karma com precisão milenar.',
    to: '/servicos/astrologia-vedica',
  },
  {
    slug: 'astro-pet',
    name: 'Astro Pet',
    shortDesc: 'Mapa natal para animais de estimação',
    fullDesc: 'Mapa natal completo para o seu animal de estimação. Revela a personalidade, necessidades emocionais e sinastria com o tutor, para uma convivência ainda mais harmoniosa.',
    to: '/servicos/astro-pet',
  },
  {
    slug: 'pergunte-aos-astros',
    name: 'Pergunte aos Astros',
    shortDesc: 'Consulta direta sobre qualquer questão',
    fullDesc: 'Faça uma pergunta específica sobre amor, trabalho, saúde ou decisões importantes e receba uma resposta astrológica completa baseada no seu mapa natal e nos trânsitos atuais.',
    to: '/servicos/pergunte-aos-astros',
  },
  {
    slug: 'astromatch',
    name: 'Astromatch',
    shortDesc: 'Compatibilidade rápida entre dois signos',
    fullDesc: 'Análise de compatibilidade entre dois mapas natais com foco em amor, comunicação e desafios. Mais profundo que comparar signos solares, analisa o mapa completo dos dois.',
    to: '/servicos/astromatch',
  },
  {
    slug: 'rota-profissional',
    name: 'Rota Profissional',
    shortDesc: 'Carreira e vocação pelo mapa natal',
    fullDesc: 'Descubra sua vocação natural, talentos ocultos e o melhor caminho profissional segundo o seu mapa natal. Inclui análise da Casa 10, Saturno e nodos lunares para orientação de carreira.',
    to: '/servicos/rota-profissional',
  },
  {
    slug: 'diario-de-sonhos',
    name: 'Diário dos Sonhos',
    shortDesc: 'Interpretação astrológica dos sonhos',
    fullDesc: 'Registre seus sonhos e receba interpretações baseadas na sua psicologia astrológica. Os sonhos são decodificados à luz da Lua, Netuno e Plutão do seu mapa natal.',
    to: '/servicos/diario-de-sonhos',
  },
  {
    slug: 'astro-coach',
    name: 'Astro Coach',
    shortDesc: 'Coaching pessoal guiado pelos astros',
    fullDesc: 'Sessões de autoconhecimento estruturadas pelo seu mapa natal. Identifique bloqueios, padrões inconscientes e ative seu potencial máximo com exercícios personalizados por ciclo astrológico.',
    to: '/servicos/astro-coach',
  },
  {
    slug: 'radar-retrogrado',
    name: 'Astros Retrógrados',
    shortDesc: 'Planetas retrógrados no seu mapa',
    fullDesc: 'Entenda o que significa ter planetas retrógrados no mapa natal e como os retrógrados em trânsito afetam você. Mercúrio, Vênus, Marte e os planetas externos interpretados especificamente.',
    to: '/servicos/radar-retrogrado',
  },
  {
    slug: 'eclipse-insight',
    name: 'Eclipse Insight',
    shortDesc: 'Eclipses e portais de transformação',
    fullDesc: 'Análise profunda de como os eclipses solares e lunares ativam pontos específicos do seu mapa natal, abrindo portais de transformação, encerramento de ciclos e novos começos.',
    to: '/servicos/eclipse-insight',
  },
  {
    slug: 'fases-da-lua',
    name: 'Fases da Lua',
    shortDesc: 'Rituais e intenções lunares personalizadas',
    fullDesc: 'As 8 fases da Lua interpretadas para o seu signo lunar e mapa natal. Saiba qual fase é ideal para plantar, colher, revisar ou descansar, com sugestões de rituais personalizados.',
    to: '/servicos/fases-da-lua',
  },
  {
    slug: 'grafologia',
    name: 'Grafologia',
    shortDesc: 'Personalidade revelada pela escrita',
    fullDesc: 'Análise da sua escrita manual combinada com o seu mapa natal para revelar traços de personalidade, bloqueios emocionais e potenciais criativos que você talvez não reconheça em si mesmo.',
    to: '/servicos/grafologia',
  },
  {
    slug: 'agenda-astrologica',
    name: 'Agenda Astrológica',
    shortDesc: 'Calendário pessoal de trânsitos e fases',
    fullDesc: 'Seu calendário pessoal com os principais eventos astrológicos do mês: trânsitos relevantes, fases da lua, retrógrados e janelas de oportunidade, tudo calculado para o seu mapa natal.',
    to: '/servicos/agenda-astrologica',
  },
];

// ─── Component ───────────────────────────────────────────────────────────────

export function SistemasSection() {
  const [expanded, setExpanded] = useState<string | null>(null);

  return (
    <section
      id="sistemas"
      style={{
        padding: 'clamp(4rem, 8vw, 7rem) 2rem',
        background: 'radial-gradient(ellipse at 50% 0%, #1A0B2E 0%, #0A0416 65%)',
        borderTop: '1px solid rgba(212,175,55,0.15)',
      }}
    >
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <p style={{
          textAlign: 'center', marginBottom: '1.5rem',
          fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 700,
          letterSpacing: '0.2em', textTransform: 'uppercase',
          color: '#D4AF37',
        }}>
          Sistemas de Leitura
        </p>
        <h2 style={{ textAlign: 'center', margin: '0 0 1rem', color: '#ffffff' }}>
          Mais de 20 sistemas. Um só lugar.
        </h2>
        <p style={{
          textAlign: 'center',
          fontFamily: 'var(--font-display)',
          fontSize: 'var(--text-18)',
          fontWeight: 300,
          color: 'rgba(255,255,255,0.55)',
          maxWidth: '540px',
          margin: '0 auto 3.5rem',
          lineHeight: 1.7,
        }}>
          Cada sistema revela uma dimensão diferente de quem você é.
        </p>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '1px',
            background: 'rgba(212,175,55,0.1)',
            border: '1px solid rgba(212,175,55,0.15)',
            borderRadius: '12px',
            overflow: 'hidden',
          }}
          className="sistemas-grid"
        >
          {SISTEMAS.map(s => {
            const isOpen = expanded === s.slug;
            return (
              <div
                key={s.slug}
                style={{
                  background: isOpen ? 'rgba(45,27,105,0.9)' : '#0F0620',
                  padding: '1.5rem',
                  cursor: 'pointer',
                  transition: 'background 0.2s ease, box-shadow 0.25s ease',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.75rem',
                  boxShadow: isOpen ? 'inset 0 0 0 1px rgba(212,175,55,0.4)' : 'none',
                }}
                onClick={() => setExpanded(isOpen ? null : s.slug)}
                role="button"
                tabIndex={0}
                aria-expanded={isOpen}
                aria-label={`${s.name}, ${s.shortDesc}`}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setExpanded(isOpen ? null : s.slug);
                  }
                }}
                onMouseEnter={e => {
                  if (!isOpen) (e.currentTarget as HTMLElement).style.background = 'rgba(26,11,46,0.9)';
                }}
                onMouseLeave={e => {
                  if (!isOpen) (e.currentTarget as HTMLElement).style.background = '#0F0620';
                }}
              >
                {/* Icon */}
                <div style={{ color: '#D4AF37', width: 48, height: 48 }}>
                  <SistemaIcon slug={s.slug} />
                </div>

                <p style={{
                  margin: 0,
                  fontFamily: 'var(--font-body)',
                  fontSize: 'var(--text-15)',
                  fontWeight: 600,
                  color: '#ffffff',
                  lineHeight: 1.3,
                }}>
                  {s.name}
                </p>
                <p style={{
                  margin: 0,
                  fontFamily: 'var(--font-body)',
                  fontSize: 'var(--text-13)',
                  color: 'rgba(255,255,255,0.5)',
                  lineHeight: 1.4,
                }}>
                  {s.shortDesc}
                </p>

                {isOpen && (
                  <div
                    onClick={e => e.stopPropagation()}
                    style={{
                      borderTop: '1px solid rgba(212,175,55,0.25)',
                      paddingTop: '0.75rem',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '0.75rem',
                    }}
                  >
                    <p style={{
                      margin: 0,
                      fontFamily: 'var(--font-display)',
                      fontSize: 'var(--text-15)',
                      fontWeight: 300,
                      color: 'rgba(255,255,255,0.7)',
                      lineHeight: 1.65,
                    }}>
                      {s.fullDesc}
                    </p>
                    <Link
                      to={s.to}
                      style={{
                        alignSelf: 'flex-start',
                        fontSize: '11px',
                        padding: '0.4rem 0.85rem',
                        fontFamily: 'var(--font-body)',
                        fontWeight: 700,
                        letterSpacing: '0.08em',
                        textTransform: 'uppercase',
                        color: '#D4AF37',
                        border: '1px solid rgba(212,175,55,0.5)',
                        borderRadius: '4px',
                        textDecoration: 'none',
                        transition: 'background 0.2s ease',
                      }}
                      onClick={e => e.stopPropagation()}
                      onMouseEnter={e => { (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(212,175,55,0.12)'; }}
                      onMouseLeave={e => { (e.currentTarget as HTMLAnchorElement).style.background = 'transparent'; }}
                    >
                      Explorar →
                    </Link>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <style>{`
        @media (max-width: 1023px) {
          .sistemas-grid { grid-template-columns: repeat(3, 1fr) !important; }
        }
        @media (max-width: 767px) {
          .sistemas-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 479px) {
          .sistemas-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
